import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'

const Upload = forwardRef(({labelText, onChange, accept, buttonText="Subir Archivo", textFilename, labelClass}, ref) => {

    const input = useRef(null);
    const [fileName, setFilename] = useState(textFilename);

    const onUpload = function(){
        input.current.click();
    }

    const onFileInputChange = (event) => {
        const files = event.target.files;
        if(files.length > 0){
            setFilename(files[0].name);
        }
        onChange(event);
    }

    useEffect(()=>{
        setFilename(textFilename);
    },[textFilename]);

    const clear = () => {
        setFilename('');
        input.current.value = '';
    }

    useImperativeHandle(ref, () => ({
        clear: clear
    }));

    return (
        <div>
            <span className={labelClass}>{labelText}</span>
            <input id="links-upload" ref={input} type='file' accept={accept} onChange={onFileInputChange} hidden={true}/>
            <button type="button" className='primary-button' onClick={onUpload}>{buttonText}</button>
            <span>{fileName}</span>
        </div>
    )
});

export default Upload;
